import React, { useState, useEffect, useRef } from 'react';
import ProfileRow from './ProfileRow';
import CanvasItem from './avwapp.chart';
import { fetchData } from './service/avwapp.service';
import { host } from './env';
import StockPopupButton from './StockPopupButton';

type QualityStocksProps = {};

export type QualityStock = {
  symbol: string;
  marketCap: number;
  volume: number;
  atr21: number;
  rsRating: number;
};

const QualityStocks: React.FC<QualityStocksProps> = ({}) => {
  const [qualityStocksData, setQualityStocksData] = useState<QualityStock[]>(
    [],
  );
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    handleQualityStocks();
  }, []);

  const fetchQualityStocksFromApi = async () => {
    try {
      const result = await fetchData(`${host}/qualityStocks`);
      setQualityStocksData(result);
    } catch (err) {
      setError('Failed to fetch quality stocks');
      console.log('err', err);
    } finally {
    }
  };

  const handleQualityStocks = async () => {
    fetchQualityStocksFromApi();
  };

  function formatMarketCap(value: number): string {
    if (value >= 1_000_000_000) {
      return (value / 1_000_000_000).toFixed(2) + 'B';
    } else if (value >= 1_000_000) {
      return (value / 1_000_000).toFixed(2) + 'M';
    } else if (value >= 1_000) {
      return (value / 1_000).toFixed(2) + 'K';
    } else {
      return value.toString();
    }
  }

  function formatPercentage(decimal: number): string {
    return (decimal * 100).toFixed(1) + '%';
  }

  return (
    <div>
      <h3 className="avwapp-subtitle">Quality Stocks based on RS &gt; 75 AND 21 day atr% &lt; 15%  AND volume &gt; 300,000,000 AND marketcap &gt; 25,000,000</h3>
      <table className="qualityStocks">
        <thead>
          <tr>
            <td>Symbol</td>
            <td>Rs rating</td>
            <td>21d atr %</td>
            <td>avg volume</td>
            <td>Market cap</td>
          </tr>
        </thead>

        {qualityStocksData.map((item: QualityStock) => (
          <tr>
            <td>{<StockPopupButton symbol={item.symbol} />}</td>
            <td>{item.rsRating}</td>
            <td>{formatPercentage(item.atr21)}</td>
            <td>{formatMarketCap(item.volume)}</td>
            <td>{formatMarketCap(item.marketCap)}</td>
          </tr>
        ))}
      </table>
    </div>
  );
};

export default QualityStocks;
